export default "__VITE_ASSET__DRFe8VMl__";